import { CardProps } from "./sy-card-interface";
import { memo } from "react";
import styleSheet from "./style.module.scss";

const SyCard = ({ title, text,chipColor='#28a745' }: CardProps) => {

  const syCardStyle = chipColor ? { backgroundColor: chipColor } : {};

  return (
    <div
      className={` rounded-3 text-white p-2 pe-4 ${styleSheet.card_style}`}
      style={syCardStyle}
    >
      <p className="sub-font mohave mb-2 fw-600">{title}</p>
      <h5 className="mohave m-0 fw-600 text-nowrap">{text}</h5>
    </div>
  );
};

export default memo(SyCard);
